import * as React from "react";
import { useHistory } from "react-router";
import { Button } from "@/components/ui";

import * as DTO from "../../../../interfaces";
import { URLS, useAccountSettings } from "../../../../utils";

import { cn } from "@/lib/utils";
import { ChevronDown, ChevronRight, Plus } from "lucide-react";
import LibraryCard from "../../../../components/Cells/LibraryCard";
import { Svg } from "@/assets";
import moment from "moment";

interface OwnProps {
  player: DTO.PlayerResumeResponse;
  videoProjects: DTO.PlayerVideoProjectResponse[];
}

type Props = OwnProps;

const VideoProjectsSearchList: React.FC<Props> = ({ player, videoProjects }) => {
  const history = useHistory();
  const [display, setDisplay] = React.useState<boolean>(true);
  const { hasWritePermission } = useAccountSettings();
  const withWritePermission = hasWritePermission(DTO.WebComponents.VIDEO_CATALYST);

  return (
    <div>
      <div
        className={cn(
          "flex items-center justify-between w-full p-2 border border-white text-foreground",
          display || "rounded-sm border-border bg-accent text-accent-foreground"
        )}
      >
        <div className="font-bold text-xl indent-1">{player.fullName}</div>
        <Button variant="ghost" size="xs" onClick={() => setDisplay(!display)}>
          {`${display ? "Show all" : "Collapsed"} (${videoProjects.length})`}
          {display ? <ChevronRight className="ml-2" /> : <ChevronDown className="ml-2" />}
        </Button>
      </div>
      {display && (
        <div className="flex gap-x-5 items-center">
          {withWritePermission && (
            <Button
              variant="outline"
              className="bg-background hover:bg-background rounded-2 my-2 border border-border border-dashed w-38 h-65 hover:shadow-md flex flex-col items-center justify-center"
              onClick={() => {
                let locationValues = { playerId: player?.playerId };
                history.push(URLS.coach.newVideoProject + "?playerId=" + player?.playerId, locationValues);
              }}
            >
              <Plus className="border rounded-full border-border size-7 p-1" />
              Add new
            </Button>
          )}
          <div className="flex gap-x-5 items-center overflow-x-auto">
            {videoProjects.map(videoProject => {
              return (
                <LibraryCard
                  key={"video_project_card_" + videoProject.videoProjectId}
                  href={URLS.coach.videoProject.replace(":id", `${videoProject.videoProjectId}`)}
                  title={videoProject.statusLabel}
                  thumbnail={videoProject.thumbnail?.thumbnailUri || Svg.PromptPlaceholder}
                  dateLabel={moment(videoProject.statusDate).format("MMM DD, YY [at] hh:mm a")}
                  className={cn("h-65 min-h-65", videoProject.needsAck && "border-warning")}
                />
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoProjectsSearchList;
